import { Injectable, EventEmitter } from '@angular/core';
import { Http, Response, RequestOptions } from '@angular/http';
import 'rxjs/add/operator/toPromise';
import 'rxjs/add/operator/map';

import { API_URL, API_LangText, API_ScreenContent } from './apiconfig';
import { PageContent } from './index.model';

//import { Http_Header_Request_Options } from './httpheader';
import { HttpHeader } from '../core/httpheader';
import { Subject } from 'rxjs';
import { Observable } from 'rxjs/Observable'

@Injectable()
export class PageContentService {

    public pageContent: PageContent;
    public pageContentYN: boolean;
    public isShowHouseCheckHistory: boolean = false;
    public houseCheckID: string;
    private apiUrl: string;
    public pdfformId: string ;
    
    private requestHeader: HttpHeader = new HttpHeader();
    private Http_Header_Request_Options: RequestOptions;
    private Subject = new Subject<any>();

    constructor(private http: Http) {
        this.apiUrl = API_URL + API_LangText;
    }

    getFormsAction() {
        this.Subject.next();
    }

    LoadFormaction():Observable<any> {
        return this.Subject.asObservable();
    }

    getKeyTxt(txtKey: string, txtLang: string): string {
        if (this.pageContent) {
            let txtContent: any;
            txtContent = this.pageContent.Content.filter(item => item.ControlName === txtKey && item.LanguageType === txtLang);

            if (txtContent.length > 0) {
                if (txtContent[0]["CustomText"]) {
                    txtContent = this.pageContent.Content.filter(item => item.ControlName === txtKey && item.LanguageType === txtLang)[0].CustomText
                }
                else if (txtContent[0]["DefaultText"]) {
                    txtContent = this.pageContent.Content.filter(item => item.ControlName === txtKey && item.LanguageType === txtLang)[0].DefaultText
                }
            }
            else {
                txtContent = "";
            }
            return txtContent;
        }
        else {
            return "";
        }
    }
    getKeyTxtStatus(txtKey: string): boolean {
        if (this.pageContent) {
            let txtContent: any;

            let retValue: boolean = true;
            txtContent = this.pageContent.Content.filter(item => item.ControlName === txtKey);

            if (txtContent.length > 0) {
                txtContent = this.pageContent.Content.filter(item => item.ControlName === txtKey)[0].IsEnabled;
            }
            else {
                return false;
            }
            return (txtContent == 1 || txtContent == null) ? true : false;
        }
        else {
            return false;
        }
    }

    getCORSKeyTxtStatus(txtKey: string): boolean {
        if (this.pageContent) {
            let txtContent: any;

            let retValue: boolean = true;
            txtContent = this.pageContent.Content.filter(item => item.ControlName === txtKey);

            if (txtContent.length > 0) {
                txtContent = this.pageContent.Content.filter(item => item.ControlName === txtKey)[0].IsTxtLanEnabled;
            }
            else {
                return false;
            }
            return (txtContent == 1 || txtContent == null) ? true : false;
        }
        else {
            return false;
        }
    }

    getTxtJurisName(txtKey: string, txtLang: string, jurisName?: string): string {
        if (this.pageContent) {
            let txtContent: any;
            txtContent = this.pageContent.Content.filter(item => item.ControlName === txtKey && item.LanguageType === txtLang);

            if (txtContent.length > 0) {
                if (txtContent[0]["CustomText"]) {
                    txtContent = this.pageContent.Content.filter(item => item.ControlName === txtKey && item.LanguageType === txtLang)[0].CustomText
                    if (txtKey == 'Home_AgencyConfirmContent') {
                        txtContent = txtContent.replace('[JurisName]', jurisName);
                    }
                }
                else if (txtContent[0]["DefaultText"]) {
                    txtContent = this.pageContent.Content.filter(item => item.ControlName === txtKey && item.LanguageType === txtLang)[0].DefaultText
                    if (txtKey == 'Home_AgencyConfirmContent') {
                        txtContent = txtContent.replace('[JurisName]', jurisName);
                    }
                }
            }
            else {
                txtContent = "";
            }
            return txtContent;
        }
        else {
            return "";
        }
    }

    get(txtTypeID: string): void {
        this.Http_Header_Request_Options = this.requestHeader.Http_Header_Request_OptionsTest();
        this.http
            .get(this.apiUrl + "/GetTextByType/" + txtTypeID, this.Http_Header_Request_Options)
            .toPromise()
            .then(response => { this.pageContent = response.json(); })
            .catch(this.handleError);
    }

    getScreenContent(screenID: number, JurisID: number) {
        this.Http_Header_Request_Options = this.requestHeader.Http_Header_Request_OptionsTest();

        return this.http
            .get(this.apiUrl + "/" + API_ScreenContent + "/" + JurisID + "/" + screenID, this.Http_Header_Request_Options)
            .toPromise()
            .then(response => {
                return response.json() as PageContent;
            })
            .catch(this.handleError);
    }

    private handleError(error: any): Promise<any> {
        console.error('An error occurred', error);
        return Promise.reject(error.message || error);
    }

}


// WEBPACK FOOTER //
// D:/NewPhoenixScrum/PhoenixScrum/Main/CitizenSevicesEx/CSClient/CSClient/client/app/core/pagecontent.service.ts